var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageTemplate',{attrs:{"datas":_vm.datas,"nv-items":_vm.nvItems,"lang":_vm.lang,"page-name":"distribution"},on:{"homeClick":_vm.homeClick}})}
var staticRenderFns = []

export { render, staticRenderFns }